export default "__VITE_ASSET__BOROQbXX__"